import { useEffect } from "react";
import Navbar from "@/components/marocanada/Navbar";
import Hero from "@/components/marocanada/Hero";
import HowItWorks from "@/components/marocanada/HowItWorks";
import Testimonial from "@/components/marocanada/Testimonial";
import Services from "@/components/marocanada/Services";
import MapSection from "@/components/marocanada/MapSection";
import TrustBar from "@/components/marocanada/TrustBar";
import Opportunity from "@/components/marocanada/Opportunity";
import CTABanner from "@/components/marocanada/CTABanner";
import Footer from "@/components/marocanada/Footer";
import WhatsAppButton from "@/components/marocanada/WhatsAppButton";
import FallbackContactCard from "@/components/marocanada/FallbackContactCard";
import { useLang } from "@/contexts/LanguageContext";
import useDocumentMeta from "@/hooks/useDocumentMeta";
import { trackCtaClick, getEligibilityUrl } from "@/lib/analytics";

const Home = () => {
  const { t, lang } = useLang();
  useDocumentMeta(lang);

  /* When arriving on / with a #hash (e.g. /#contact from About page CTA),
   * scroll to that section once the DOM has mounted. */
  useEffect(() => {
    if (!window.location.hash) return;
    const id = window.location.hash.slice(1);
    const tryScroll = (attempt = 0) => {
      const el = document.getElementById(id);
      if (el) {
        el.scrollIntoView({ behavior: "smooth", block: "start" });
      } else if (attempt < 10) {
        setTimeout(() => tryScroll(attempt + 1), 120);
      }
    };
    // small delay to allow framer-motion / lazy sections to mount
    setTimeout(() => tryScroll(0), 200);
  }, []);

  return (
    <main data-testid="home-page" className="bg-[#0D1117] text-[#F5F2EE]">
      <Navbar />

      {/* 01 — Hero */}
      <Hero />

      {/* 02 — Process */}
      <HowItWorks />

      {/* 03 — Social Proof / Stories */}
      <Testimonial />

      {/* 04 — Services grid */}
      <Services />

      {/* The Opportunity (editorial light interlude) */}
      <Opportunity />

      {/* 05 — Interactive Map */}
      <MapSection />

      {/* 06 — Trust Bar (Atlas Snow) */}
      <TrustBar />

      {/* 07 — CTA Finale */}
      <CTABanner />

      {/* Profile assessment external CTA (Home only) */}
      <section
        data-testid="profile-eval-cta"
        className="bg-[#0D1117] flex flex-col items-center justify-center text-center px-6"
        style={{ paddingTop: 60, paddingBottom: 60 }}
      >
        <p className="font-body text-sm sm:text-base text-[#F5F2EE]/65 max-w-xl mb-7">
          {t.cta.evalIntro}
        </p>
        <a
          href={getEligibilityUrl(lang)}
          data-testid="profile-eval-button"
          onClick={() => trackCtaClick("profile-eval")}
          className="inner-border-btn group inline-flex items-center justify-center gap-3 bg-[#2FBFAD] hover:bg-[#239B8C] text-[#0D1117] px-9 py-4 rounded-full font-mono-accent text-[11px] font-medium tracking-wider whitespace-nowrap transition-colors"
        >
          <span>{t.cta.evalButton}</span>
        </a>

        <div className="mt-8">
          <FallbackContactCard />
        </div>
      </section>

      {/* 08 — Footer */}
      <Footer />

      <WhatsAppButton />
    </main>
  );
};

export default Home;
